/**
 * The stored name of a tenant's Literal E constancia (DGI form 6361 / 6906).
 *
 * Canonical here because THREE places must agree on it: the portal that
 * uploads the file, the backend route that stores it under a server-side name,
 * and the reviewer surface that looks it up. It is already in normalized form —
 * normalizeCompanyDocumentName("literal_e_proof") yields exactly this — so a
 * row written with it is indistinguishable from one a user named by hand.
 */
export const LITERAL_E_PROOF_DOCUMENT_NAME = "literal-e-proof";

/** Max length for the stored display / download base name (excluding file extension). */
export const MAX_COMPANY_DOCUMENT_NAME_LENGTH = 200;

/**
 * Normalizes a user-provided document label to lowercase kebab-case
 * (e.g. "Inscripción DGI" → "inscripcion-dgi").
 */
export function normalizeCompanyDocumentName(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed === "") {
    return "document";
  }

  const withoutCombiningMarks = trimmed
    .normalize("NFKD")
    .replace(/\p{M}/gu, "");

  const lower = withoutCombiningMarks.toLowerCase();

  const slug = lower
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-")
    .slice(0, MAX_COMPANY_DOCUMENT_NAME_LENGTH);

  return slug === "" ? "document" : slug;
}
